import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { t } from 'src/lib/language';

const CancelTaxReceiptButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );
  const lang = useSelector((state: Store) => state.language.language);

  const { disabled } = props;

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.cancelTaxReceipt }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.cancel_tax_receipt')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled || !selections.length}>
            <ReceiptIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default CancelTaxReceiptButton;
